import Card from '@/components/Card/Card';
import { mapActions } from 'vuex';

export default {
  name: 'logout',
  components: {
    Card
  },
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {
    setTimeout(() => {
      this._logout().then(() => {
        this.$router.push({ path: '/' });
      });
    }, 2000);
  },
  methods: {
    ...mapActions({
      _logout: 'entities/context/logout'
    })
  }
};
